import { useCallback, useEffect } from 'react';
import { noop } from '@yme/common/index';
import { DigitalDataMutation, setDigitalData } from '@yme/utils/common';
export function useInitOnlineSizingSettings({ apiKey, lang, generalFeatureId, config, onClickHandler, }) {
    const checkIsAvailable = useCallback(() => true, []);
    const sizingAvailable = useCallback(() => noop, []);
    const confirmSize = useCallback((payload) => {
        if (payload?.code && onClickHandler) {
            return onClickHandler({
                sku: payload.code,
                size: payload.size || payload.displaySize01,
            });
        }
        return noop;
    }, [onClickHandler]);
    const confirmSizeUnavailable = useCallback((payload) => {
        onClickHandler({
            sku: payload.code,
            size: payload.size || payload.displaySize01,
        });
    }, [onClickHandler]);
    const usageInsights = useCallback((payload) => {
        delete payload['oz-meta'];
        const eventName = payload['event'];
        if (typeof eventName !== 'string') {
            return;
        }
        setDigitalData(DigitalDataMutation.SMART_FIT_USAGE_INSIGHTS, {
            event: eventName,
            payload,
        });
    }, []);
    const confirmSizeDoesNotFit = useCallback(({ code, size, displaySize01 }) => {
        onClickHandler({
            sku: code,
            size: size || displaySize01,
        });
    }, [onClickHandler]);
    useEffect(() => {
        if (apiKey && lang && generalFeatureId) {
            window.___OnlineSizingConfig = {
                settings: {
                    apiKey,
                    language: lang,
                    ...config,
                },
                events: {
                    usageInsights: {
                        callback: usageInsights,
                    },
                    checkIsAvailable: {
                        callback: checkIsAvailable,
                    },
                    sizingAvailable: {
                        callback: sizingAvailable,
                    },
                    confirmSize: {
                        callback: confirmSize,
                    },
                    confirmSizeUnavailable: {
                        callback: confirmSizeUnavailable,
                    },
                    confirmSizeDoesNotFit: {
                        callback: confirmSizeDoesNotFit,
                    },
                },
            };
            window.___OnlineSizing = generalFeatureId;
        }
    }, [
        apiKey,
        lang,
        generalFeatureId,
        config,
        checkIsAvailable,
        sizingAvailable,
        confirmSize,
        confirmSizeUnavailable,
        confirmSizeDoesNotFit,
        usageInsights,
    ]);
}
